<template>
  <exo-help-dialog margin="mt-0 ml-2" title="Enable mass loss after maneuvers">
    It is possible to specify a loss of mass after each maneuver, the typical
    use case is a dispenser. This will have an impact on the following maneuvers
    (e.g. duration, consumption,...).
  </exo-help-dialog>
</template>

<script>
export default {
  name: 'tooltipEnableMassLossAfterManeuvers'
}
</script>
